export const emojiArray = [
  '/::)', // 微笑
  '/::~', // 撇嘴
  '/::B', // 色
  '/::|', // 发呆
  '/:8-)', // 得意
  '/::<', // 流泪
  '/::$', // 害羞
  '/::X', // 闭嘴
  '/::Z', // 睡
  "/::'(", // 大哭
  '/::-|', // 尴尬
  '/::@', // 发怒
  '/::P', // 调皮
  '/::D', // 呲牙
  '/::O', // 惊讶
  '/::(', // 难过
  '/::+', // 酷
  '/:--b', // 冷汗
  '/::Q', // 抓狂
  '/::T', // 吐
  '/:,@P', // 偷笑
  '/:,@-D', // 可爱
  '/::d', // 白眼
  '/:,@o', // 傲慢
  '/::g', // 饥饿
  '/:|-)', // 困
  '/::!', // 惊恐
  '/::L', // 流汗
  '/::>', // 憨笑
  '/::,@', // 大兵
  '/:,@f', // 努力
  '/::-S', // 咒骂
  '/:?', // 疑问
  '/:,@x', // 嘘
  '/:,@@', // 晕
  '/::8', // 折磨
  '/:,@!', // 衰
  '/:!!!', // 骷髅
  '/:xx', // 敲打
  '/:bye', // 再见
  '/:wipe', // 擦汗
  '/:dig', // 抠鼻
  '/:handclap', // 鼓掌
  '/:&-(', // 溴大了
  '/:B-)', // 坏笑
  '/:<@', // 左哼哼
  '/:@>', // 右哼哼
  '/::-O', // 哈欠
  '/:>-|', // 鄙视
  '/:P-(', // 委屈
  "/::'|", // 快哭了
  '/:X-)', // 阴险
  '/::*', // 亲亲
  '/:@x', // 吓
  '/:8*', // 可怜
  '/:pd', // 菜刀
  '/:<W>', // 西瓜
  '/:beer', // 啤酒
  '/:basketb', // 篮球
  '/:oo', // 乒乓
  '/:coffee', // 咖啡
  '/:eat', // 饭
  '/:pig', // 猪头
  '/:rose', // 玫瑰
  '/:fade', // 凋谢
  '/:showlove', // 示爱
  '/:heart', // 爱心
  '/:break', // 心碎
  '/:cake', // 蛋糕
  '/:li', // 闪电
  '/:bome', // 炸弹
  '/:kn', // 刀
  '/:footb', // 足球
  '/:ladybug', // 瓢虫
  '/:shit', // 便便
  '/:moon', // 月亮
  '/:sun', // 太阳
  '/:gift', // 礼物
  '/:hug', // 拥抱
  '/:strong', // 强
  '/:weak', // 弱
  '/:share', // 握手
  '/:v', // 胜利
  '/:@)', // 抱拳
  '/:jj', // 勾引
  '/:@@', // 拳头
  '/:bad', // 差劲
  '/:lvu', // 爱你
  '/:no', // No
  '/:ok', // Ok
  '/:love', // 爱情
  '/:<L>', // 飞吻
  '/:jump', // 跳舞
  '/:shake', // 发抖
  '/:<O>', // 怄火
  '/:circle', // 转圈
  '/:kotow', // 磕头
  '/:turn', // 回头
  '/:skip', // 跳绳
  '/:oY', // 挥手
  '/:#-0', // 激动
  '/:hiphot', // 街舞 // hiphot doesnot work!
  '/:kiss', // 献吻
  '/:<&', // 左太极
  '/:&>' // 右太极
]

export const emojiArrayV2 = [
  '\uD83D\uDC4D',
  '\uD83D\uDE00',
  '\uD83D\uDE02',
  '\uD83D\uDE01',
  '\uD83D\uDE03',
  '\uD83D\uDE04',
  '\uD83D\uDE05',
  '\uD83D\uDE06',
  '\uD83D\uDE09',
  '\uD83D\uDE0A',
  '\uD83D\uDE0B',
  '\uD83D\uDE0E',
  '\uD83D\uDE0D',
  '\uD83D\uDE18',
  '\uD83D\uDE17',
  '\uD83D\uDE19',
  '\uD83D\uDE1A',
  '☺',
  '\uD83D\uDE07',
  '\uD83D\uDE10',
  '\uD83D\uDE11',
  '\uD83D\uDE36',
  '\uD83D\uDE0F',
  '\uD83D\uDE23',
  '\uD83D\uDE25',
  '\uD83D\uDE2E',
  '\uD83D\uDE2F',
  '\uD83D\uDE2A',
  '\uD83D\uDE2B',
  '\uD83D\uDE34',
  '\uD83D\uDE0C',
  '\uD83D\uDE1B',
  '\uD83D\uDE1C',
  '\uD83D\uDE1D',
  '\uD83D\uDE12',
  '\uD83D\uDE13',
  '\uD83D\uDE14',
  '\uD83D\uDE15',
  '\uD83D\uDE32',
  '\uD83D\uDE37',
  '\uD83D\uDE16',
  '\uD83D\uDE1E',
  '\uD83D\uDE1F',
  '\uD83D\uDE24',
  '\uD83D\uDE22',
  '\uD83D\uDE2D',
  '\uD83D\uDE26',
  '\uD83D\uDE27',
  '\uD83D\uDE28',
  '\uD83D\uDE2C',
  '\uD83D\uDE30',
  '\uD83D\uDE31',
  '\uD83D\uDE33',
  '\uD83D\uDE35',
  '\uD83D\uDE21',
  '\uD83D\uDE20',
  '\uD83D\uDC4B',
  '\uD83E\uDD1A',
  '\uD83D\uDD90',
  '✋',
  '\uD83D\uDD96',
  '\uD83D\uDC4C',
  '\uD83E\uDD0F',
  '✌️',
  '\uD83E\uDD1E',
  '\uD83E\uDD1F',
  '\uD83E\uDD18',
  '\uD83E\uDD19',
  '\uD83D\uDC48',
  '\uD83D\uDC49',
  '\uD83D\uDC46',
  '\uD83D\uDD95',
  '\uD83D\uDC47',
  '☝️',
  '\uD83D\uDC4E',
  '✊',
  '\uD83D\uDC4A',
  '\uD83E\uDD1B',
  '\uD83E\uDD1C',
  '\uD83D\uDC4F',
  '\uD83D\uDE4C',
  '\uD83D\uDC50',
  '\uD83E\uDD32',
  '\uD83E\uDD1D',
  '\uD83D\uDE4F',
  '❤️',
  '\uD83D\uDC94',
  '\uD83D\uDCA6',
  '\uD83C\uDF89',
  '☀️',
  '\uD83C\uDF19',
  '⭐️',
  '\uD83D\uDC90',
  '\uD83C\uDF38',
  '\uD83C\uDF39',
  '\uD83C\uDF3A',
  '\uD83C\uDF3B',
  '\uD83C\uDF3C',
  '\uD83C\uDF37',
  '\uD83C\uDF31',
  '\uD83C\uDF3F',
  '\uD83C\uDF40',
  '\uD83D\uDE08',
  '\uD83D\uDC80',
  '\uD83D\uDC7B',
  '\uD83C\uDF83',
  '\uD83D\uDE84',
  '\uD83D\uDE87',
  '\uD83D\uDE8C',
  '⏰',
  '\uD83D\uDD25',
  '\uD83C\uDF4E',
  '\uD83D\uDCB0',
  '\uD83D\uDC8E',
  '\uD83D\uDD2A',
  '\uD83D\uDD2B',
  '\uD83C\uDFC0',
  '⚽',
  '⚡',
  '\uD83C\uDF49',
  '\uD83C\uDF4B',
  '\uD83C\uDF4C',
  '\uD83C\uDF4E',
  '\uD83C\uDF50',
  '\uD83C\uDF52',
  '\uD83C\uDF5E',
  '\uD83C\uDF57',
  '\uD83C\uDF54',
  '\uD83C\uDF5A',
  '\uD83C\uDF5C',
  '\uD83C\uDF66',
  '\uD83C\uDF82',
  '\uD83C\uDF6D',
  '\uD83C\uDF7C',
  '☕',
  '\uD83C\uDF75',
  '\uD83C\uDF77',
  '\uD83C\uDF7A',
  '\uD83C\uDF74',
  '\uD83E\uDD10',
  '\uD83E\uDD7A',
]

const otherEmojiObj: any = {
  '/:<&': 103, // 左太极
  '/:&>': 104, // 右太极
}

const regStr = "/::\\)|/::~|/::B|/::\\||/:8-\\)|/::<|/::\\$|/::X|/::Z|/::'\\(|/::-\\||/::@|/::P|/::D|/::O|/::\\(|/::\\+|/:--b|/::Q|/::T|/:,@P|/:,@-D|/::d|/:,@o|/::g|/:\\|-\\)|/::!|/::L|/::>|/::,@|/:,@f|/::-S|/:\\?|/:,@x|/:,@@|/::8|/:,@!|/:!!!|/:xx|/:bye|/:wipe|/:dig|/:handclap|/:&-\\(|/:B-\\)|/:<@|/:@>|/::-O|/:>-\\||/:P-\\(|/::'\\||/:X-\\)|/::\\*|/:@x|/:8\\*|/:pd|/:<W>|/:beer|/:basketb|/:oo|/:coffee|/:eat|/:pig|/:rose|/:fade|/:showlove|/:heart|/:break|/:cake|/:li|/:bome|/:kn|/:footb|/:ladybug|/:shit|/:moon|/:sun|/:gift|/:hug|/:strong|/:weak|/:share|/:v|/:@\\)|/:jj|/:@@|/:bad|/:lvu|/:no|/:ok|/:love|/:<L>|/:jump|/:shake|/:<O>|/:circle|/:kotow|/:turn|/:skip|/:oY|/:#-0|/:hiphot|/:kiss|/:<&|/:&>"

let regStrV2 = emojiArrayV2.reduce((prev, item) => {
  return prev + '|' + item
}, '')

let regStrAll = regStr + regStrV2

export function transformEmoji(message: string) {
  if (!message) {
    return ''
  }
  message = message.replace(/[\n]/ig, '<br/>')
  const linkReg = /(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|#|\/|%|-|:)+)/g
  message = message.replace(linkReg, '<a href="$1$2" class="custom-link" target="_blank">$1$2</a>')
  const reg = new RegExp(regStrAll, 'g')
  message = message.replace(reg, function (r) {
    if (emojiArray.indexOf(r) > -1) {
      const qqFaceSrc = `https://upload.techgp.cn/production/im/emoji/${emojiArray.indexOf(r)}.png`
      return `<img class="emojiMsg" code="${r}" src="${qqFaceSrc}" oncontextmenu="return false"/>`
    } else if (emojiArrayV2.indexOf(r) > -1) {
      let name
      if (emojiArrayV2.indexOf(r) < 9) {
        name = 'ic_emoji_0' + (emojiArrayV2.indexOf(r) + 1)
      } else {
        name = 'ic_emoji_' + (emojiArrayV2.indexOf(r) + 1)
      }
      const qqFaceSrc = `https://upload.techgp.cn/production/static/article/${name}.png`;
      return `<img class="emojiMsg" code="${r}" src="${qqFaceSrc}" oncontextmenu="return false"/>`;
    }
    else if (Object.keys(otherEmojiObj).indexOf(r) > -1) {
      const qqFaceSrc = `https://upload.techgp.cn/production/im/emoji/${otherEmojiObj[r]}.png`
      return `<img class="emojiMsg" code="${r}" src="${qqFaceSrc}" oncontextmenu="return false"/>`
    }
    else {
      return message
    }
  })
  return message.replace(/[\n]/ig, '<br/>')
}

export function transformPhone(phone: string) {
  if (!phone) return
  return phone.replace(/(\d{3})(\d{4})(\d{4})/, "$1****$3")
}
